import { Box, Icon, Modal, Select } from '@deity-io/portal-ui';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import {
  GetAllPackageVersionsDocument,
  GetPackageVersionDocument,
  useGetPackageVersionQuery,
  useUpdatePackageVersionStatusMutation
} from 'services/graphql/generated/hooks';
import { ContentStatus } from 'services/graphql/generated/schemas';
import { getParams } from 'utils';

type ModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};
export const PublishPackageVersionModal: FC<ModalProps> = ({ isOpen, setIsOpen }) => {
  const { pathname } = useLocation();
  const params = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);

  const [publishPackageVersion] = useUpdatePackageVersionStatusMutation({
    variables: {
      uuid: params?.versionUuid,
      status: ContentStatus.Published
    },
    refetchQueries: [
      {
        query: GetPackageVersionDocument,
        variables: {
          uuid: params?.versionUuid
        }
      },
      {
        query: GetAllPackageVersionsDocument,
        variables: {
          packageUuid: params?.packageId,
          limit: 20,
          offset: 0
        }
      }
    ]
  });
  const { data } = useGetPackageVersionQuery({
    variables: {
      uuid: params?.versionUuid
    },
    skip: !params?.versionUuid,
    ...CACHE_FIRST
  });

  return data?.getPackageVersion?.version ? (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Save & publish package version"
      closeIcon={<Icon icon="close" />}
      confirmText="Save & publish"
      onConfirm={async () => {
        await publishPackageVersion();
        setIsOpen(false);
      }}
    >
      <Box my={2}>
        <p>You&apos;ve been editing the following version:</p>

        <Select
          onChange={() => {}}
          options={[{ label: data.getPackageVersion.version, value: params.versionUuid }]}
          value={{ label: data.getPackageVersion.version, value: params.versionUuid }}
          autoSelect
          disabled
        />

        <Box mt={2} px={3} py={2} bgcolor="#fffceb" borderLeft="5px solid #ecc155">
          <p>After publication, this package will become available for deployment to one of your environments</p>
        </Box>
      </Box>
    </Modal>
  ) : null;
};
